import sanitize from 'sanitize-html';
import ent from 'ent';

const removeRedundantLines = value =>
  value.replace(/(?:(?:\r\n|\r|\n)\s*){2}/gm, '\n');

// @apavlosiuk: sanitize-html replaces such symbols as "&", "<", ">", etc. with the corresponding
// html entites: "&amp;", "&lt;", "&gt;". That's why we need to decode its result.
const sanitizeInputNodeValue = value =>
  ent.decode(
    sanitize(removeRedundantLines(value), {
      // disallow all tags and attributes: https://github.com/punkave/sanitize-html#what-if-i-dont-want-to-allow-any-tags
      allowedTags: [],
      allowedAttributes: [],
    }),
  );

export default sanitizeInputNodeValue;
